import React from 'react'
import PropTypes from 'prop-types'
import {
  RiHome2Line,
  RiHome2Fill,
  RiDashboardFill,
  RiDashboardLine,
  RiMenuLine,
  RiCameraFill,
  RiVipDiamondFill,
  RiVipCrownFill,
  RiEmpathizeFill,
  RiLightbulbFill,
  RiCheckLine,
  RiLoginBoxLine,
  RiNewspaperLine,
  RiTodoLine,
  RiSettings2Line,
  RiCloseFill,
  RiHome3Fill,
  RiLockPasswordLine,
  RiEyeOffFill,
  RiEyeFill,
  RiSpyLine,
  RiEditFill,
  RiPencilFill,
  RiGuideFill,
  RiListCheck,
  RiTeamFill,
  RiFile2Line,
  RiMessageFill,
  RiEdit2Fill,
  RiCheckFill,
  RiCloseCircleFill
} from 'react-icons/ri'
import { FaLanguage, FaWhatsapp, FaRegWindowClose } from 'react-icons/fa'
import { Icon } from '@iconify/react'
function WidgetIcons ({ name, ...props }) {
  if (props.type === 'iconify') {
    return <Icon icon={name} {...props}/>
  }

  switch (name) {
    case 'RiHome2Line':
      return <RiHome2Line {...props} />
    case 'RiHome2Fill':
      return <RiHome2Fill {...props} />
    case 'RiDashboardFill':
      return <RiDashboardFill {...props} />
    case 'RiDashboardLine':
      return <RiDashboardLine {...props} />
    case 'RiMenuLine':
      return <RiMenuLine {...props} />
    case 'RiCameraFill':
      return <RiCameraFill {...props} />
    case 'RiVipDiamondFill':
      return <RiVipDiamondFill {...props} />
    case 'RiVipCrownFill':
      return <RiVipCrownFill {...props} />
    case 'RiEmpathizeFill':
      return <RiEmpathizeFill {...props} />
    case 'RiLightbulbFill':
      return <RiLightbulbFill {...props} />
    case 'RiCheckLine':
      return <RiCheckLine {...props} />
    case 'RiLoginBoxLine':
      return <RiLoginBoxLine {...props} />
    case 'RiNewspaperLine':
      return <RiNewspaperLine {...props} />
    case 'RiTodoLine':
      return <RiTodoLine {...props} />
    case 'RiSettings2Line':
      return <RiSettings2Line {...props} />
    case 'RiCloseFill':
      return <RiCloseFill {...props} />
    case 'RiHome3Fill':
      return <RiHome3Fill {...props} />
    case 'RiLockPasswordLine':
      return <RiLockPasswordLine {...props} />
    case 'RiEyeOffFill':
      return <RiEyeOffFill {...props} />
    case 'RiEyeFill':
      return <RiEyeFill {...props} />
    case 'RiSpyLine':
      return <RiSpyLine {...props} />
    case 'RiEditFill':
      return <RiEditFill {...props} />
    case 'RiPencilFill':
      return <RiPencilFill {...props} />
    case 'RiGuideFill':
      return <RiGuideFill {...props} />
    case 'RiListCheck':
      return <RiListCheck {...props} />
    case 'RiTeamFill':
      return <RiTeamFill {...props} />
    case 'FaLanguage':
      return <FaLanguage {...props} />
    case 'RiFile2Fill':
      return <RiFile2Line {...props} />
    case 'WhatsApp':
      return <FaWhatsapp {...props} />
    case 'RiMessageFill':
      return <RiMessageFill {...props} />
    case 'RiEdit2Fill':
      return <RiEdit2Fill {...props} />
    case 'RiCheckFill':
      return <RiCheckFill {...props} />
    case 'RiCloseCircleFill':
      return <RiCloseCircleFill {...props} />
    case 'FaRegWindowClose':
      return <FaRegWindowClose {...props} />

    default:
      return null
  }
}

WidgetIcons.propTypes = {
  name: PropTypes.string.isRequired
}

export default WidgetIcons
